/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
  props: {
    value: {
      type: [String, Number]
    },
    list: {
      type: Array,
      required: true
    },
    showBadge: {
      type: Boolean,
      default: false
    },
    badgeCountList: {
      type: Object
    },
    isScroller: {
      type: Boolean,
      default: false
    },
    rightWidth: {
      type: Number
    },
    showAll: {
      type: Boolean,
      default: false
    },
    allValue: {
      type: [String, Number]
    }
  },
  data: function data() {
    return {
      realValue: this.value,
      hasRightSlot: false,
      nowIndex: 0,
      scrollTop: 0,
      badgeCount: {}
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['pageReload'])),
  watch: {
    value: function value(val) {
      if (this.value !== undefined) {
        this.realValue = val;
      }
    },
    realValue: function realValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    },
    list: function list(val) {
      if (val && val.length > 0) {
        this.getBadgeCount();
      }
    }
  },
  mounted: function mounted() {
    this.$slots.right && (this.hasRightSlot = true);

    // 滚动至默认激活位置
    if (this.isScroller && this.value !== undefined && this.list.length > 0) {
      this.scrollTop = 0;
      this.nowIndex = this.list.map(function (item) {
        return item.value;
      }).indexOf(this.value);
      if (this.nowIndex > 0) {
        var liWidth = this.$refs.smyTabList.map(function (item) {
          return item.offsetWidth;
        });
        for (var i = 0; i < this.nowIndex; i++) {
          this.scrollTop += liWidth[i];
        }
        this.$refs.smyTab.scrollTo(this.scrollTop, 0);
      }
    }
    // console.log(this.$refs.smyTabList[2].offsetWidth)
  },
  methods: {},
  created: function created() {
    if (!this.showBadge) {
      if (this.value === undefined && this.list.length > 0) {
        this.realValue = this.list[0].value;
      }
    }
  }
};